/* eslint jsx-a11y/no-onchange: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { useState } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { addProductToCart, removeOneProduct, getCart, emptyCart } from "../../utils/cart";
import arrow from "../../assets/arrow-down.svg";

import {
  Container,
  Title,
  P,
  Select,
  Price,
  Desc,
  Content,
  PriceContainer,
  InnerContent,
  Separator,
  MobileContainer,
  MobileDescription,
  ResumeContainer,
  HideMobile,
  ShowMobile,
  Button,
  ButtonsContainer,
  ModalP,
  ModalTitle,
  SelectorContainer,
  Chip
} from "./Components";
import Dialog from '@material-ui/core/Dialog';

const ProductCard = ({ product, pack, resumeView, onPackChange, producerSlug, producerName, updateCart = () => { } }) => {

  const [value, setValue] = useState(pack ? pack : '');
  const [lostValue, setLostValue] = useState(null);
  const [mobileDescription, setMobileDescription] = useState(false);

  const toogleMobileDescription = () => {
    const temp = mobileDescription;
    setMobileDescription(!temp);
  }

  const [updatedPrice, setUpdatedPrice] = useState(() => {
    if (pack && (pack !== "null")) {
      // Check if exist a discount
      let price = 0.00;

      if (product.discount && product.discount.active && product.discount.price) {
        price = product.discount.price;
      } else {
        price = product.price;
      }

      switch (pack) {
        case 'pack2':
          return ((price * 2).toFixed(2));
        case 'pack3':
          return ((price * 3).toFixed(2));
        default:
          return (price.toFixed(2));
      }
    } else {
      return 0.00;
    }
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const [producerFromCart, setProducerFromCard] = useState({
    name: '',
    slug: ''
  });

  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const productSelectHandler = (value) => {
    let res = 0;

    if (value === "null") {
      // Remove product
      removeOneProduct(product);
      updateCart();
    } else {
      // Add product to cart
      res = addProductToCart({
        ...product,
        pack: value,
        producerSlug: producerSlug,
        producerName: producerName
      });

      if (res === -1) {
        const cart = getCart();
        setProducerFromCard({
          name: cart.producerName,
          slug: cart.producerSlug
        });
        setLostValue(value);
        handleClickDialogOpen();
      }
    }

    if (res !== -1) {
      // Update select
      setValue(value);

      // Check if exist a discount
      let price = 0.00;

      if (value !== "null") {
        if (product.discount && product.discount.active && product.discount.price) {
          price = product.discount.price;
        } else {
          price = product.price;
        }
      }

      // Update frontend price
      switch (value) {
        case 'pack2':
          setUpdatedPrice((price * 2).toFixed(2));
          break;
        case 'pack3':
          setUpdatedPrice((price * 3).toFixed(2));
          break;
        case 'pack1':
          setUpdatedPrice(price.toFixed(2));
          break;
        default:
          setUpdatedPrice(price.toFixed(2));
      }

      // Used to update total on resume page
      if (onPackChange) {
        onPackChange();
      }

      updateCart();

    }

  }

  const resetCard = () => {
    emptyCart();
    if (lostValue) {
      productSelectHandler(lostValue);
      setLostValue(null);
    }
    handleDialogClose();
    updateCart();
  }

  const getRightPrice = (product) => {
    let price = 0.00;
    if (product.discount && product.discount.active && product.discount.price) {
      price = product.discount.price;
    } else {
      price = product.price;
    }
    return price
  }

  const { title, type, year, description, grapeVarieties, image } = product;

  const productPrice = getRightPrice(product);

  return (
    <Container resumeView={resumeView}>
      <div style={{
        minWidth: resumeView ? '150px' : '300px',
        width: resumeView ? '150px' : '300px',
        height: resumeView ? '150px' : '300px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
        position: 'relative',
      }}>
        <Image
          style={{
            minWidth: resumeView ? '100px' : '200px',
            maxWidth: resumeView ? '150px' : '300px',
            width: 'auto',
            height: '100%',
            maxHeight: resumeView ? '150px' : '400px'
          }}
          fluid={image.childImageSharp.fluid}
        />
        {(!resumeView && productPrice) && <Chip><b style={{ marginRight: '2px' }}>€{(productPrice || '').toFixed(2)}</b>/<span style={{ marginLeft: '2px' }}>pack</span></Chip>}
      </div>
      {resumeView ? (
        <ResumeContainer>
          <HideMobile>
            <div style={{ display: 'flex', flexDirection: 'column', paddingRight: '12px' }}>
              <b><P hideMobile marginBottom="5px">Produtor:</P></b>
              <P hideMobile fontSize="20px" margin="0px">{title}</P>
              <P hideMobile margin="0px">{type} - {year}</P>
              <P hideMobile margin="0px">{`Pack de ${parseInt(value[4]) * 3} garrafas`}</P>
            </div>
          </HideMobile>
          <ShowMobile>
            <h3 style={{ color: "#B6936C", fontSize: "22px", margin: "10px 10px 10px 0" }}>{title}</h3>
          </ShowMobile>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <SelectorContainer>
              <b><P marginBottom="5px">Quantidade:</P></b>
              <HideMobile>
                <Select small className="selectCustomArrow" value={value} onChange={(event) => productSelectHandler(event.target.value)}>
                  <option value="pack1">1 Pack de três garrafas</option>
                  <option value="pack2">2 Packs de três garrafas</option>
                  <option value="pack3">3 Packs de três garrafas</option>
                </Select>
              </HideMobile>
              <ShowMobile>
                <Select small className="selectCustomArrow" value={value} onChange={(event) => productSelectHandler(event.target.value)}>
                  <option value="pack1">1 Pack</option>
                  <option value="pack2">2 Packs</option>
                  <option value="pack3">3 Packs</option>
                </Select>
              </ShowMobile>
            </SelectorContainer>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <b><P hideMobile marginBottom="5px">Preço:</P></b>
              <P hideMobile>€{parseFloat(updatedPrice).toFixed(2)}</P>
            </div>
          </div>
        </ResumeContainer>
      ) : (
          <Content>
            <Title margin="0px 20px 0 0">{title}</Title>
            <P>{type} - {year}</P>
            <div style={{ display: 'flex', }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <b><P marginBottom="5px">Quantidade:</P></b>
                {/* // eslint-disable-next-line no-use-before-define */}
                <Select value={value} onChange={(event) => productSelectHandler(event.target.value)}>
                  <option defaultValue value="null">Escolha um Pack</option>
                  <option value="pack1">1 Pack de três garrafas</option>
                  <option value="pack2">2 Packs de três garrafas</option>
                  <option value="pack3">3 Packs de três garrafas</option>
                </Select>
              </div>
              <PriceContainer>
                <b><P nowrap marginBottom="5px">Sub-total:</P></b>
                <Price>€{parseFloat(updatedPrice).toFixed(2)}</Price>
              </PriceContainer>
            </div>
            <InnerContent>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <b><P marginBottom="5px">Breve descrição:</P></b>
                <Desc>{description}</Desc>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '40px' }}>
                <b><P marginBottom="5px">Castas:</P></b>
                <Desc>{grapeVarieties}</Desc>
              </div>
            </InnerContent>
            {
              !mobileDescription ? (
                <MobileContainer onClick={toogleMobileDescription}>
                  <div style={{ display: 'flex', height: '20px' }}>
                    <Separator />
                    <P nowrap bold center>Ver mais</P>
                    <Separator />
                  </div>
                  <img style={{ width: '15px', height: 'auto' }} src={arrow} alt="more-description" />
                </MobileContainer>
              ) : (
                  <MobileDescription>
                    <div onClick={toogleMobileDescription}>
                      <img style={{ width: '15px', fill: 'white', height: 'auto', transform: 'rotate(180deg)', marginLeft: '48%' }} src={arrow} alt="more-description" />
                    </div>
                    <b><P marginBottom="5px" color="white">Breve descrição:</P></b>
                    <Desc color="white">{description}</Desc>
                    <b><P marginBottom="5px" color="white">Castas:</P></b>
                    <Desc color="white">{grapeVarieties}</Desc>
                  </MobileDescription>
                )
            }
          </Content>
        )}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ margin: '20px' }}>
          <ModalP color="#B89976" center>Tem produtos selecionados de outro produtor</ModalP>
          <ModalTitle>As encomendas têm de ser feitas a um produtor de cada vez</ModalTitle>
          <ModalP color="#B89976" center>Ao "continuar" vai perder os produtos selecionados anteriormente</ModalP>
          <ButtonsContainer>
            <Link to={`/producer/${producerFromCart.slug}`}>
              <Button marginRight="10px" main>Voltar ao produtor anterior</Button>
            </Link>
            <Button marginLeft="10px" onClick={resetCard}>Continuar</Button>
          </ButtonsContainer>
        </div>
      </Dialog>
    </Container>
  );
};

export default ProductCard;
